'use client';

import { Add01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { SplitActionButton } from '../../split-action-button/SplitActionButton';
import {
  INTERNAL_NETWORK_CREDENTIAL_TYPES,
  type InternalNetworkCredentialType,
} from './internal-credentials.model';

type InternalNetworkCredentialsAddButtonProps = {
  disabled?: boolean;
  tooltip?: string;
  onAdd: (credentialType: InternalNetworkCredentialType) => void;
};

export function InternalNetworkCredentialsAddButton({
  disabled,
  tooltip,
  onAdd,
}: InternalNetworkCredentialsAddButtonProps) {
  const t = useTranslations('designSystem.networkSettings.internalCredentials');
  const tCommon = useTranslations('designSystem.common');
  const menuItems = INTERNAL_NETWORK_CREDENTIAL_TYPES.map((credentialType) => ({
    value: credentialType,
    label: t(`credentialTypes.${credentialType}`),
    disabled,
    disabledTitle: tooltip,
    onSelect: () => {
      onAdd(credentialType);
    },
  }));

  return (
    <SplitActionButton
      primaryLabel={
        <>
          <Add01Icon size={16} />
          {tCommon('add')}
        </>
      }
      primaryAriaLabel={t('addCredential')}
      primaryAutomationId="internal-network-settings-add-credential"
      primaryDisabled={disabled}
      primaryTooltip={tooltip}
      onPrimaryClick={() => {
        onAdd('DOMAIN_USER');
      }}
      menuTriggerAriaLabel={t('addCredential')}
      menuTriggerDisabled={disabled}
      menuItems={menuItems}
      groupTooltip={tooltip}
    />
  );
}
